import React from 'react';
import PropTypes from 'prop-types';
import { HelpCircle } from 'lucide-react';
import { getRatioColorClass, getBackgroundClass, getTextColorClass } from '../../utils/valuationDashboardUtils';

/**
 * FinancialRatioCard - Display a single financial ratio with color coding
 * Used in ValuationDashboard to show financial ratios with benchmarking
 */
const FinancialRatioCard = ({ ratioName, value, unit, category, onHelpClick }) => {
  const color = getRatioColorClass(ratioName, value);

  // Custom display names for specific ratios that need proper capitalization
  const ratioDisplayNames = {
    'ebitdaMargin': 'EBITDA Margin',
    'roa': 'ROA',
    'roe': 'ROE'
  };

  // Get display name - use custom if available, otherwise convert camelCase to Title Case
  const displayName = ratioDisplayNames[ratioName] ||
    ratioName.replace(/([A-Z])/g, ' $1').trim().replace(/^./, str => str.toUpperCase());

  return (
    <div
      className={`relative bg-gradient-to-br ${getBackgroundClass(color, category)} rounded-lg p-4 border cursor-pointer transition-all hover:shadow-md flex flex-col`}
      onClick={() => onHelpClick(ratioName)}
    >
      <p className="text-xs font-medium text-gray-600 mb-1 whitespace-nowrap">
        {displayName}
      </p>
      <p className={`text-xl font-bold ${getTextColorClass(color)} mb-2`}>
        {typeof value === 'number' ? value.toFixed(unit === 'x' ? 2 : 1) : value}{unit}
      </p>
      <div className="flex justify-center mt-auto">
        <HelpCircle size={12} className="text-gray-400" />
      </div>
    </div>
  );
};

FinancialRatioCard.propTypes = {
  ratioName: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  onHelpClick: PropTypes.func.isRequired
};

export default FinancialRatioCard;
